module.exports = __webpack_public_path__ + "img/ic-check-ac.80800b52.svg";